import { Card, Row, Spin } from "antd";
import { memo, useCallback, useState } from "react";
import { IntervalSelector } from "../IntervalSelector";
import { useFetchData } from "./hooks/useFetchData";
import { useCalcPecentage } from "./hooks/useCalcPercentage";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../../lib/constants";
import { useDoubleLineChartConfig } from "../../hooks/useDoubleLineChartConfig";
import { Line } from "@ant-design/plots";
import { DefaultLegend } from "../DefaultLegend";

type VisitsPerDeviceProps = {
  isDataLoading: boolean;
  isRecalculated: boolean;
};

const VisitsPerDevice = ({
  isDataLoading,
  isRecalculated,
}: VisitsPerDeviceProps) => {
  const [granularity, setGranularity] = useState<number>(1);

  const { data, isLoading } = useFetchData(granularity, isRecalculated);

  const { desktopPercentage, mobilePercentage } = useCalcPecentage(data);

  const getColor = useCallback(({ type }: { type: string }): string => {
    return type === "Desktop" ? CHART_PAID_OFF : CHART_DEFAULT;
  }, []);

  const { config } = useDoubleLineChartConfig(data, getColor);

  return (
    <Card className="dashboard-card top">
      <Row className="justify-space-between align-center">
        <p className="text my-0">Portal Visits per Device</p>
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
      <Row className="d-block h-100">
        {!isDataLoading && !isLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">{desktopPercentage.toFixed()}%</h3>
                <p className="my-0 text-sm title">desktop</p>
              </Row>
              <Row className="d-block">
                <h3 className="h h3">{mobilePercentage.toFixed()}%</h3>
                <p className="my-0 text-sm title">mobile</p>
              </Row>
            </Row>

            <Line {...config} />

            <DefaultLegend first="Desktop" second="Mobile" />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};

export default memo(VisitsPerDevice);
